<template>
  <div class="topbar">
    <el-row>
      <el-col :sm="8" :md="8">
        <div class="brand-logo">
          <a style="cursor:pointer;" @click="goBack()"><img src="@/assets/img/logo-white.png"></a>
        </div>
        <div v-if="showpartnerlogo" class="partner-logo">
          <img class="icon-close-light" src="@/assets/img/close_light.png" />
          <img :src="imgurl" />
        </div>
      </el-col>
      <el-col :sm="16" :md="16">
        <div class="topbar-right">
          <el-menu :default-active="activeIndex" mode="horizontal">
            <el-submenu index="1" popper-class="topbar-right-submenu-lan">
              <template slot="title">{{ currentlang }}</template>
              <el-menu-item index="1-1"><el-button type="text" size="mini" @click="setLanguage('中文')">中文</el-button></el-menu-item>
              <el-menu-item index="1-2"><el-button type="text" size="mini" @click="setLanguage('English')">English</el-button></el-menu-item>
              <el-menu-item index="1-3"><el-button type="text" size="mini" @click="setLanguage('日本語')">日本語</el-button></el-menu-item>
            </el-submenu>
            <el-menu-item index="2"><a style="cursor:pointer;" @click="tonewticket()">{{ $t("PageCommon.SubmitaTicket") }}</a></el-menu-item>
            <el-menu-item index="3"><a href="https://simplybrand.kf5.com/hc/request/listview/" target="_blank">{{ $t("PageCommon.MyTickets") }}</a></el-menu-item>
            <el-menu-item index="6" v-if="showurl"><router-link :to="'/Personal/Report/' + brandid">{{ $t("SidebarMenu.Menu10") }}</router-link></el-menu-item>
            <el-submenu index="4" popper-class="topbar-right-submenu">
              <template slot="title">{{ $t("SidebarMenu.Menu96") }}</template>
              <el-menu-item-group>
                <span slot="title"><i class="el-icon-caret-right"></i>{{ $t("SidebarMenu.Menu95") }}</span>
                <el-menu-item index="4-3-1">
                  <router-link :to="'/Personal/Profile/' + brandid">{{ $t("SidebarMenu.Menu08") }}</router-link>
                </el-menu-item>
                <el-menu-item index="4-3-2">
                  <router-link :to="'/Personal/MyVip/' + brandid">{{ $t("SidebarMenu.Menu98") }}</router-link>
                </el-menu-item>
              </el-menu-item-group>
              <el-divider></el-divider>
              <el-menu-item-group>
                <span slot="title"><i class="el-icon-caret-right"></i>{{ $t("SidebarMenu.Menu94") }}</span>
                <el-menu-item index="4-4-2" v-if="showmodelsetting">
                  <router-link :to="'/Personal/ModelSetting/' + brandid">{{ $t("SidebarMenu.Menu91") }}</router-link>
                </el-menu-item>
                <el-menu-item index="4-4-3">
                  <router-link :to="'/Personal/Notifications/' + brandid">{{ $t("SidebarMenu.Menu93") }}</router-link>
                </el-menu-item>
                <el-menu-item index="4-4-4">
                  <router-link :to="'/Personal/CouponSetting/' + brandid">{{ $t("SidebarMenu.Menu92") }}</router-link>
                </el-menu-item>
                <el-menu-item index="4-4-5" v-if="showskusettingbtn">
                  <router-link :to="'/Personal/SKUSetting/' + brandid">{{ $t("SidebarMenu.Menu88") }}</router-link>
                </el-menu-item>
                <el-menu-item index="4-4-6">
                  <router-link :to="'/Personal/DiscountSetting/' + brandid">{{ $t("discount.discountsetting") }}</router-link>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="5" popper-class="topbar-right-submenu-logout">
              <template slot="title">{{ username }}</template>
              <el-menu-item index="5-1"><a href="javascript:;" @click="onLoginout">{{ $t("PageCommon.Logout") }}</a></el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
      </el-col>
    </el-row>
  </div>  
</template>

<script>
export default {
  
  data () {
    return {
      currentlang: '',
      showuserminicard: false,
      langs : '',
      username : '',
      companyname : '',
      balance : 0,
      userstatuscode: '',
      logourl: false,
      defaultid: '',
      brandid: this.$route.params.Id,
      gotospuid: this.$route.params.Id,
      isspu: this.$route.path.indexOf('SPU') != -1 ? true : false,
      showpartnerlogo: false,
      imgurl: '',
      showmodelsetting: false,
      logodata: {},
      activeIndex: '0',
      showurl: false,
      showskusettingbtn: false
    }
  },

  mounted() {
    
    this.getPartnerLogo()

    if(window.localStorage.getItem('localeLanguage')){
      if(window.localStorage.getItem('localeLanguage') === 'zh'){
        this.currentlang = '中文'
      }
      if(window.localStorage.getItem('localeLanguage') === 'en'){
        this.currentlang = 'English'
      }
      if(window.localStorage.getItem('localeLanguage') === 'jp'){
        this.currentlang = '日本語'
      }
    }else{
      this.currentlang = '中文'
    }
    this.langs = window.localStorage.getItem('localeLanguage') ? window.localStorage.getItem('localeLanguage') === 'en'?'中':'EN' : 'EN'
    if(window.localStorage.getItem('status')){
      this.userstatuscode = JSON.parse(window.localStorage.getItem('status')).val
      this.username = window.localStorage.getItem('name') ? JSON.parse(window.localStorage.getItem('name')).val : '--'
      this.companyname = window.localStorage.getItem('company') ? JSON.parse(window.localStorage.getItem('company')).val : '--'
      this.balance = this.balance
    }else{
      this.userstatuscode = 99
    }
    
    if(window.localStorage.getItem('commmerce')){
      this.logourl = JSON.parse(window.localStorage.getItem('commmerce')).val.length > 0 ? true : false
      if(JSON.parse(window.localStorage.getItem('commmerce')).val.length > 0){
        this.defaultid = '/MyBrand/Product/' + JSON.parse(window.localStorage.getItem('commmerce')).val[0].id + ''
      }
    }

    this.showmodelsetting = JSON.parse(window.localStorage.getItem('userinfo')).val.role/1 === 0 ? true : false

    let pkglist = JSON.parse(localStorage.getItem("price")).val
    let currentpkg = pkglist.find(o => o.subid/1 === this.brandid/1)
    this.showurl = currentpkg.url != '' && currentpkg.url != undefined && currentpkg.url != null ? true : false

    if(currentpkg.level/1 == 5 || this.$route.params.Id == 173){
      this.showskusettingbtn = true
    }

  },

  methods : {

    /**
     * 切换语言
     */
    changeLanguage : function() {
      if (this.$i18n.locale == 'en') {
        this.$i18n.locale = 'zh';
        this.langs = 'EN';
        window.localStorage.setItem('localeLanguage', this.$i18n.locale)
        this.$store.state.lan = this.$i18n.locale
      } else {
        this.$i18n.locale = 'en';
        this.langs = '中';
        window.localStorage.setItem('localeLanguage', this.$i18n.locale)
        this.$store.state.lan = this.$i18n.locale
      }
    },

    /**
     * 设置语言
     */
    setLanguage: function(command){
      if(command === '中文'){
        this.$i18n.locale = 'zh';
        window.localStorage.setItem('localeLanguage', this.$i18n.locale)
      }
      if(command === 'English'){
        this.$i18n.locale = 'en';
        window.localStorage.setItem('localeLanguage', this.$i18n.locale)
      }
      if(command === '日本語'){
        this.$i18n.locale = 'jp';
        window.localStorage.setItem('localeLanguage', this.$i18n.locale)
      }
      this.$store.state.lan = this.$i18n.locale
      window.location.reload()
      this.currentlang = command
    },

    /**
     * 发送退出请求
     * 保留用户当前设置的语言
     */
    onLoginout: function(){
      var that = this
      let url = that.API_URL + '/v3/users/logout';
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        success: function(rex) {
          let currentlan = localStorage.getItem("localeLanguage")

          if(JSON.parse(localStorage.getItem("isremenber")).val === true){
            /**
             * 清除localstorage并重新写入密码资料
             */
            let _email = JSON.parse(localStorage.getItem("loginemail")).val
            let _passwd = JSON.parse(localStorage.getItem("loginpasswd")).val
            let _isremenber = JSON.parse(localStorage.getItem("isremenber")).val
            
            localStorage.clear()
            that.setLocalStorage( "isremenber", _isremenber )
            that.setLocalStorage( "loginemail", _email )
            that.setLocalStorage( "loginpasswd", _passwd )
          }else{
            localStorage.clear()
          }

          window.localStorage.setItem('localeLanguage', currentlan)
          that.$router.push({ path: "/Login" })
        },
        error: function(response) {
          console.log(response)
        }
      })
    },

    tonewticket: function(){
      this.getKf5SsoToken()
    },

    /**
     * 获取kf5 SSO Token
     */
    getKf5SsoToken: function(){
      let that = this
      let url = that.API_URL + '/v3/users/kftoken'
      $.ajax({
        url:  url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          let kf5url = 'http://simplybrand.kf5.com/user/remote?username=' + rex.username 
          + '&time=' + rex.time 
          + '&token=' + rex.token
          + '&return_to=' + 'https://simplybrand.kf5.com/hc/request/new/'
          + '&rememberMe=0'

          var a = document.createElement('a')
          a.href = kf5url
          a.target = '_blank'
          $("body").append(a)
          a.click()
          $(a).remove()

        },
        error: function(response) {
          console.log(response)
        }
      })
    },

    /**
     * 点击返回
     */
    goBack: function(){
      let that = this
      let pkgprice = JSON.parse(localStorage.getItem("price")).val
      let pkgcommmerce = JSON.parse(localStorage.getItem("commmerce")).val
      console.log(pkgprice)
      console.log(pkgcommmerce)
      if(pkgprice.length > 0){
        let defaultIds = pkgprice[0].subid
        that.$router.push({name: 'PriceMonitoringProduct', params: {Id: defaultIds}})
      }else{
        if(pkgcommmerce.length > 0){
          let defaultId = pkgcommmerce[0].id
          that.$router.push({name: 'Product', params: {Id: defaultId}})
        }else{
          that.$router.push({ path: "/PriceMonitoring" })
        }
      }      
    },

    /**
     * 获取合作伙伴Logo
     */
    getPartnerLogo: function(){
      let that = this
      let userid = JSON.parse(window.localStorage.getItem('userinfo')).val.mainid/1
      let url = that.API_URL + '/partnerlogo/partnerlogo.json?time=' + that.$moment(new Date())
      $.ajax({
        url:  url,
        type: "GET",
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          that.logodata = rex
          
          // 判定是否合作伙伴登录
          let partners = [0]
          for(let i=0; i<rex.partnerlogo.length; i++){
            partners.push(rex.partnerlogo[i].partnerid)
          }
          if(partners.indexOf(userid) != -1){
            let _imgurl = ''
            for(let i=0; i<rex.partnerlogo.length; i++){
              if(rex.partnerlogo[i].partnerid == userid){
                _imgurl = rex.partnerlogo[i].logourl
              }
            }
            that.showpartnerlogo = true
            that.imgurl = that.API_URL + _imgurl
          }

          // 判定是否是代理订阅
          let subids = [0]
          for(let i=0; i<rex.partnerlogo.length; i++){
            subids = subids.concat(rex.partnerlogo[i].subid)
          }
          if(subids.indexOf(that.brandid/1) != -1){
            let _imgurl = ''
            let _mail = ''
            for(let i=0; i<rex.partnerlogo.length; i++){
              for(let j=0; j<rex.partnerlogo[i].subid.length; j++){
                if(rex.partnerlogo[i].subid[j] == that.brandid/1){
                  _imgurl = rex.partnerlogo[i].logourl
                  _mail = rex.partnerlogo[i].email
                }
              }
            }
            that.showpartnerlogo = true
            that.imgurl = that.API_URL + _imgurl
            that.$store.state.partneremail = _mail
          }
        },
        error: function(response) {
          console.log('getPartnerLogo', response)
        }
      })
    },    

  }
}
</script>
